import theme from '../../theme';
function PlannerDiagram() {
  return (
    <svg width="100%" viewBox="0 0 680 272" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <marker id="arrow" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse">
          <path d="M2 1L8 5L2 9" fill="none" stroke="context-stroke" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </marker>
      </defs>

      {/* Citizens */}
      <rect x="20" y="38" width="150" height="178" rx="12" fill="#E1F5EE" stroke="#0F6E56" strokeWidth="0.5"/>
      <text x="95" y="65" textAnchor="middle" dominantBaseline="central" fontSize="14" fontWeight="500" fill="#085041">Citizens</text>

      <rect x="30" y="84" width="130" height="32" rx="6" fill="#9FE1CB" stroke="#0F6E56" strokeWidth="0.5" opacity="0.5"/>
      <text x="118" y="100" textAnchor="middle" dominantBaseline="central" fontSize="12" fill="#085041">Want bread?</text>
      <ellipse cx="50" cy="95" rx="9" ry="5" fill="#085041" opacity="0.5"/>
      <rect x="41" y="95" width="18" height="11" rx="3" fill="#085041" opacity="0.5"/>

      <rect x="30" y="124" width="130" height="32" rx="6" fill="#9FE1CB" stroke="#0F6E56" strokeWidth="0.5" opacity="0.5"/>
      <text x="118" y="140" textAnchor="middle" dominantBaseline="central" fontSize="12" fill="#085041">Want medicine?</text>
      <rect x="47" y="130" width="5" height="18" rx="2" fill="#c0392b" opacity="0.7"/>
      <rect x="40" y="137" width="18" height="5" rx="2" fill="#c0392b" opacity="0.7"/>

      <rect x="30" y="164" width="130" height="32" rx="6" fill="#9FE1CB" stroke="#0F6E56" strokeWidth="0.5" opacity="0.5"/>
      <text x="118" y="180" textAnchor="middle" dominantBaseline="central" fontSize="12" fill="#085041">Want shoes?</text>
      <rect x="37" y="185" width="24" height="5" rx="2" fill="#085041" opacity="0.5"/>
      <rect x="37" y="174" width="16" height="13" rx="6" fill="#085041" opacity="0.5"/>

      {/* Hidden barrier */}
      <rect x="173" y="44" width="68" height="170" fill="#E24B4A" opacity="0.05"/>
      <line x1="173" y1="44" x2="173" y2="214" stroke="#E24B4A" strokeWidth="1" strokeDasharray="5 3" opacity="0.5"/>
      <text x="207" y="105" textAnchor="middle" fontSize="12" fill="#E24B4A">hidden</text>
      <text x="207" y="121" textAnchor="middle" fontSize="12" fill="#E24B4A">from planner</text>
      <text x="207" y="168" textAnchor="middle" fontSize="32" fill="#E24B4A" opacity="0.2">?</text>

      {/* Central Planner */}
      <rect x="246" y="28" width="162" height="202" rx="12" fill="#FAECE7" stroke="#993C1D" strokeWidth="1"/>
      <text x="327" y="56" textAnchor="middle" dominantBaseline="central" fontSize="14" fontWeight="500" fill="#712B13">Central Planner</text>
      <text x="327" y="76" textAnchor="middle" dominantBaseline="central" fontSize="12" fill="#993C1D">You</text>
      <rect x="307" y="90" width="40" height="50" rx="4" fill="#993C1D" opacity="0.15"/>
      <rect x="315" y="86" width="24" height="8" rx="3" fill="#993C1D" opacity="0.3"/>
      <line x1="313" y1="106" x2="341" y2="106" stroke="#993C1D" strokeWidth="1.5" opacity="0.35"/>
      <line x1="313" y1="116" x2="341" y2="116" stroke="#993C1D" strokeWidth="1.5" opacity="0.35"/>
      <line x1="313" y1="126" x2="333" y2="126" stroke="#993C1D" strokeWidth="1.5" opacity="0.35"/>
      <text x="327" y="160" textAnchor="middle" fontSize="12" fill="#712B13">100W · 100M · 100E</text>
      <text x="327" y="178" textAnchor="middle" fontSize="12" fill="#712B13">Allocate resources</text>
      <text x="327" y="198" textAnchor="middle" fontSize="12" fill="#712B13">Must guess demand</text>

      {/* Arrow */}
      <line x1="410" y1="128" x2="483" y2="128" stroke={theme.textMuted} strokeWidth="1.5" markerEnd="url(#arrow)"/>
      <text x="447" y="120" textAnchor="middle" fontSize="12" fill={theme.textMuted}>plan</text>

      {/* Factories */}
      <rect x="487" y="38" width="162" height="178" rx="12" fill="#EEEDFE" stroke="#534AB7" strokeWidth="0.5"/>
      <text x="568" y="65" textAnchor="middle" dominantBaseline="central" fontSize="14" fontWeight="500" fill="#26215C">Factories</text>

      <rect x="497" y="84" width="142" height="32" rx="6" fill="#CECBF6" stroke="#534AB7" strokeWidth="0.5" opacity="0.5"/>
      <text x="586" y="100" textAnchor="middle" dominantBaseline="central" fontSize="12" fill="#26215C">Bread</text>
      <ellipse cx="516" cy="95" rx="9" ry="5" fill="#26215C" opacity="0.5"/>
      <rect x="507" y="95" width="18" height="11" rx="3" fill="#26215C" opacity="0.5"/>

      <rect x="497" y="124" width="142" height="32" rx="6" fill="#CECBF6" stroke="#534AB7" strokeWidth="0.5" opacity="0.5"/>
      <text x="586" y="140" textAnchor="middle" dominantBaseline="central" fontSize="12" fill="#26215C">Medicine</text>
      <rect x="513" y="130" width="5" height="18" rx="2" fill="#c0392b" opacity="0.7"/>
      <rect x="506" y="137" width="18" height="5" rx="2" fill="#c0392b" opacity="0.7"/>

      <rect x="497" y="164" width="142" height="32" rx="6" fill="#CECBF6" stroke="#534AB7" strokeWidth="0.5" opacity="0.5"/>
      <text x="586" y="180" textAnchor="middle" dominantBaseline="central" fontSize="12" fill="#26215C">Shoes</text>
      <rect x="503" y="185" width="24" height="5" rx="2" fill="#26215C" opacity="0.5"/>
      <rect x="503" y="174" width="16" height="13" rx="6" fill="#26215C" opacity="0.5"/>

      {/* Footer labels */}
      <text x="95" y="252" textAnchor="middle" fontSize="12" fill={theme.textMuted}>Real demand</text>
      <text x="327" y="252" textAnchor="middle" fontSize="12" fill={theme.textMuted}>No price signals</text>
      <text x="568" y="252" textAnchor="middle" fontSize="12" fill={theme.textMuted}>Production output</text>
    </svg>
  );
}

export default PlannerDiagram;